import gql from 'graphql-tag';

const BLOG_ENTRY_QUERY = gql`
    query BlogEntries ($slug: String!) {
        blogEntries (where: {slug: $slug}) {
            id
            date
            title
            summary
            text
            hero {
                url
            }
            published_at
            reviewed_at
            admin_user {
                firstname
                lastname
            }
            blog_type
            slug
            event_date_start
            event_date_end
            event_richtext
            event_url
            contact_enabled
            contact_name
            contact_text
            contact_notify_email
        }
    }
`;

export default BLOG_ENTRY_QUERY;
